var newsroomVideo = document.getElementById('video-news');

if(newsroomVideo) {
    var btn = document.querySelectorAll("a.video-trigger");
    var modals = document.querySelectorAll('.modal');
    var spans = document.getElementsByClassName("close");

    const stopVideo = (iframe) => {
        const src = iframe.getAttribute("src");
        iframe.setAttribute("src", src);
    }

    for (var i = 0; i < btn.length; i++) {
        btn[i].onclick = function(e) {
            e.preventDefault();
            var modal = document.querySelector(e.target.getAttribute("href"));
            console.log(modal)
            modal.style.display = "block";
        }
    }

    for (var i = 0; i < spans.length; i++) {
        spans[i].onclick = function() {
            for (var index in modals) {
                if (typeof modals[index].style !== 'undefined') {
                    modals[index].style.display = "none";

                    const iframe = modals[index].querySelector('iframe');
                    stopVideo(iframe);
                }
            }
        }
    }

    window.onclick = function(event) {
        if (event.target.classList.contains('modal')) {
            for (var index in modals) {
                if (typeof modals[index].style !== 'undefined') {
                    modals[index].style.display = "none";

                    const iframe = modals[index].querySelector('iframe');
                    stopVideo(iframe);
                }
            }
        }
    }
}
